import { Button } from "@/components/ui/button";

const url = (invoiceId: string) =>
  `http://lf.tabula.de/project/${import.meta.env.VITE_LANGFUSE_PROJECT_ID}/traces?filter=sessionId%3Bstring%3B%3B%3D%3B${invoiceId}&dateRange=90d`;
export const LangfuseLink = ({ invoiceId }: { invoiceId: string }) => {
  return (
    <Button asChild>
      <a href={url(invoiceId)}>Go to Session</a>
    </Button>
  );
};
